import { render, staticRenderFns } from "./TotalEmissionReductions.vue?vue&type=template&id=08414d65&scoped=true"
import script from "./TotalEmissionReductions.vue?vue&type=script&lang=js"
export * from "./TotalEmissionReductions.vue?vue&type=script&lang=js"
import style0 from "./TotalEmissionReductions.vue?vue&type=style&index=0&id=08414d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08414d65",
  null
  
)

export default component.exports